import React from "react";
import { Helmet } from "react-helmet-async";
import { IPageContainerProps } from "./IPageContainer";
import { Box } from "@mui/material";

export const PageContainer: React.FC<IPageContainerProps> = (props) => {
  const { title, description } = props;

  return (
    <Box id="page-container">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Helmet>
      {props.children}
    </Box>
  );
};
